import React from 'react';
import './RAGAnalysis.css';

const RAGMetadataPanel = ({ metadata }) => {
    return null;
};

export default RAGMetadataPanel;
